import styled from 'styled-components';
import theme from 'fe-appdir-lib-theme';

const AppCardWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: ${(p) =>
    p.isFocused ? theme.colorGrey20 : theme.colorWhite};
  font-family: ${theme.fontFamilyPrimary};
  cursor: pointer;
  box-shadow: ${theme.boxShadowCard};

  &:focus {
    outline: none;
    box-shadow: ${theme.boxShadowCardRaised};
  }
`;

AppCardWrapper.displayName = 'AppCardWrapper';

export { AppCardWrapper };
